module.exports = __webpack_public_path__ + "img/clock-indicating-messages-unread.705663c7.jpg";